export const CASHIER_TYPE = {
	INTERNAL: 1,
	EXTERNAL: 2
};
